// extracted by mini-css-extract-plugin
export default {"content":"legalsPage_content__SrOr9"};